import React from 'react';
import { Link } from 'react-router-dom';
import { Bitcoin, Twitter, Github, Linkedin, Send } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-neutral-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <div className="relative w-9 h-9">
                <div className="absolute inset-0 rounded-lg" style={{ background: 'linear-gradient(135deg, #8247E5, #A855F7)', boxShadow: '0 4px 14px rgba(130,71,229,0.35)' }} />
                <div className="absolute inset-0 flex items-center justify-center">
                  <svg viewBox="0 0 40 40" className="w-5 h-5" fill="none">
                    <path d="M12 8 L20 4 L28 8 L28 16 L20 20 L12 16 Z" fill="white" opacity="0.95" />
                    <path d="M12 24 L20 20 L28 24 L28 32 L20 36 L12 32 Z" fill="white" opacity="0.7" />
                  </svg>
                </div>
              </div>
              <span className="font-display font-bold text-xl">TokenGate</span>
            </Link>
            <p className="mt-4 text-sm text-neutral-600 max-w-xs leading-relaxed">
              Turn your crypto into real-world spending. Gift cards, mobile refills, eSIMs and token swaps, all paid with your crypto.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="w-9 h-9 rounded-lg bg-neutral-100 flex items-center justify-center hover:bg-[#8247E5] hover:text-white transition-colors"><Twitter className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-neutral-100 flex items-center justify-center hover:bg-[#8247E5] hover:text-white transition-colors"><Send className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-neutral-100 flex items-center justify-center hover:bg-[#8247E5] hover:text-white transition-colors"><Github className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-neutral-100 flex items-center justify-center hover:bg-[#8247E5] hover:text-white transition-colors"><Linkedin className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-neutral-900 mb-4">Products</h4>
            <ul className="space-y-2 text-sm text-neutral-600">
              <li><Link to="/browse" className="hover:text-[#8247E5]">Gift Cards</Link></li>
              <li><Link to="/swap" className="hover:text-[#8247E5]">Token Swap</Link></li>
              <li><Link to="/mobile-topup" className="hover:text-[#8247E5]">Mobile Refill</Link></li>
              <li><Link to="/esim" className="hover:text-[#8247E5]">eSIM</Link></li>
              <li><Link to="/browse/crypto" className="hover:text-[#8247E5]">Crypto Services</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm text-neutral-900 mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-neutral-600">
              <li><a href="#" className="hover:text-[#8247E5]">About</a></li>
              <li><a href="#" className="hover:text-[#8247E5]">Blog</a></li>
              <li><a href="#" className="hover:text-[#8247E5]">Careers</a></li>
              <li><a href="#" className="hover:text-[#8247E5]">Press</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm text-neutral-900 mb-4">Support</h4>
            <ul className="space-y-2 text-sm text-neutral-600">
              <li><a href="#" className="hover:text-[#8247E5]">Help Center</a></li>
              <li><a href="mailto:support@tokengate.in" className="hover:text-[#8247E5]">Contact</a></li>
              <li><a href="#" className="hover:text-[#8247E5]">Terms</a></li>
              <li><a href="#" className="hover:text-[#8247E5]">Privacy</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-neutral-200 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-neutral-500">© {new Date().getFullYear()} TokenGate. Est. 2026. All rights reserved.</p>
          <p className="text-xs text-neutral-500 flex items-center gap-1">Non-custodial · 20+ assets · Zero platform fees</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
